export default __webpack_public_path__ + "static/media/bg5.a2c71e94.png";